import { DGATE_CAMPAIGN_TRACKER_PAGE_LAYOUT_VERSION, DGATE_CT_APP_VERSION } from './version';

export const environment = {
  production: true,
  version: DGATE_CT_APP_VERSION,
  apiBaseUrl: '',
  defaultLang: 'en',
  campaignTrackerPageLayoutVersion: DGATE_CAMPAIGN_TRACKER_PAGE_LAYOUT_VERSION,
  agGridLicenseKey:
    'Using_this_{AG_Grid}_Enterprise_key_{AG-097588}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{GG_Development_Kft.}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{DGate}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{DGate}_need_to_be_licensed___{DGate}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{6_February_2027}____[v3]_[01]_MTgwMTg3MjAwMDAwMA==775c8383ddea80ce43020b5a571367b9',
};
